import { useContext } from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { UserContext } from "../context/userContext";

const ALLOW_GROUPS = [1, 7];

const RequireAuth = ({ root = false }) => {
  const { user, loadingUser } = useContext(UserContext);
  const location = useLocation();

  if (loadingUser) return null;

  if (root) {
    if (!user) {
      return <Navigate to="/acp/Account/Login" replace />;
    }

    if (user.groupId == null) {
      return null;
    }

    if (!ALLOW_GROUPS.includes(Number(user.groupId))) {
      window.location.href = "https://i-law.vn/";
      return null;
    }

    return <Navigate to="/acp" replace />;
  }

  if (!user) {
    return (
      <Navigate
        to={`/acp/Account/Login?ReturnUrl=${encodeURIComponent(
          location.pathname
        )}`}
        replace
      />
    );
  }
  if (user.groupId == null) {
    return null;
  }
  if (!ALLOW_GROUPS.includes(Number(user.groupId))) {
    window.location.href = "https://i-law.vn/";
    return null;
  }

  return <Outlet />;
};

export default RequireAuth;
